export const moduleCatalog = [
  {
    code: 1000,
    title: '概览',
    uri: 'overview-control',
    icon: 'el-icon-odometer',
    children: [
      {
        code: 1100,
        title: '工作台',
        path: '/dashboard',
        permissionUri: 'dashboard-view',
        actions: [
          {
            code: 1101,
            uri: 'dashboard-view',
            name: '工作台查看'
          }
        ]
      }
    ]
  },
  {
    code: 2000,
    title: '权限管理',
    uri: 'permission-control',
    icon: 'el-icon-lock',
    children: [
      {
        code: 2100,
        title: '角色列表',
        path: '/role-control/list',
        permissionUri: 'role-list',
        actions: [
          {
            code: 2101,
            uri: 'role-list',
            name: '角色列表'
          },
          {
            code: 2102,
            uri: 'role-add',
            name: '角色新增'
          },
          {
            code: 2103,
            uri: 'role-edit',
            name: '角色编辑'
          },
          {
            code: 2104,
            uri: 'role-delete',
            name: '角色删除'
          }
        ]
      },
      {
        code: 2200,
        title: '管理员列表',
        path: '/user-control/list',
        permissionUri: 'manage-list',
        actions: [
          {
            code: 2201,
            uri: 'manage-list',
            name: '管理员列表'
          },
          {
            code: 2202,
            uri: 'manage-add',
            name: '管理员新增'
          },
          {
            code: 2203,
            uri: 'manage-edit',
            name: '管理员编辑'
          },
          {
            code: 2204,
            uri: 'manage-delete',
            name: '管理员删除'
          }
        ]
      }
    ]
  },
  {
    code: 3000,
    title: '系统设置',
    uri: 'setting-control',
    icon: 'el-icon-setting',
    children: [
      {
        code: 3100,
        title: '基础设置',
        path: '/setting/system',
        permissionUri: 'setting-all',
        actions: [
          {
            code: 3101,
            uri: 'setting-all',
            name: '系统设置查看'
          },
          {
            code: 3102,
            uri: 'setting-save',
            name: '系统设置保存'
          }
        ]
      }
    ]
  },
  {
    code: 4000,
    title: '茶类管理',
    uri: 'tea-control',
    icon: 'el-icon-collection-tag',
    children: [
      {
        code: 4100,
        title: '茶类列表',
        path: '/tea-setting/list',
        permissionUri: 'tea-setting-list',
        actions: [
          {
            code: 4101,
            uri: 'tea-setting-list',
            name: '茶类列表'
          },
          {
            code: 4102,
            uri: 'tea-setting-add',
            name: '茶类新增'
          },
          {
            code: 4103,
            uri: 'tea-setting-update',
            name: '茶类编辑'
          },
          {
            code: 4104,
            uri: 'tea-setting-del',
            name: '茶类删除'
          }
        ]
      }
    ]
  },
  {
    code: 5000,
    title: '冲泡配置',
    uri: 'brew-control',
    icon: 'el-icon-data-line',
    children: [
      {
        code: 5100,
        title: '冲泡配置',
        path: '/brew-setting/list',
        permissionUri: 'brew-setting-list',
        actions: [
          {
            code: 5101,
            uri: 'brew-setting-list',
            name: '冲泡配置查看'
          },
          {
            code: 5102,
            uri: 'brew-setting-save',
            name: '冲泡配置保存'
          }
        ]
      }
    ]
  },
  {
    code: 7000,
    title: '用户数据',
    uri: 'member-control',
    icon: 'el-icon-user-solid',
    children: [
      {
        code: 7100,
        title: '用户列表',
        path: '/member/list',
        permissionUri: 'member-list',
        actions: [
          {
            code: 7101,
            uri: 'member-list',
            name: '用户列表'
          }
        ]
      },
      {
        code: 7200,
        title: '泡法列表',
        path: '/soak/list',
        permissionUri: 'user-soak-list',
        actions: [
          {
            code: 7201,
            uri: 'user-soak-list',
            name: '泡法列表'
          },
          {
            code: 7202,
            uri: 'user-soak-export',
            name: '泡法导出'
          }
        ]
      }
    ]
  },
  {
    code: 6000,
    title: '投诉建议',
    uri: 'feedback-control',
    icon: 'el-icon-chat-dot-square',
    children: [
      {
        code: 6100,
        title: '建议列表',
        path: '/feedback/list',
        permissionUri: 'feedback-list',
        actions: [
          {
            code: 6101,
            uri: 'feedback-list',
            name: '建议列表'
          },
          {
            code: 6102,
            uri: 'feedback-detail',
            name: '建议详情'
          },
          {
            code: 6103,
            uri: 'feedback-handle',
            name: '建议处理'
          }
        ]
      }
    ]
  }
];
